import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "calendar--container" }
const _hoisted_2 = {
  key: 0,
  class: "calendar--controls calendar--controls-arrow"
}
const _hoisted_3 = {
  key: 1,
  class: "calendar--controls"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.withArrow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["calendar--button", { 'calendar--button-unvisible': !$setup.showPrevArrow }]),
            onClick: $setup.prevMonth
          }, "‹", 2),
          _createElementVNode("span", null, _toDisplayString($setup.months[$setup.selectedMonth - 1]) + " " + _toDisplayString($setup.selectedYear), 1),
          _createElementVNode("button", {
            class: _normalizeClass(["calendar--button", { 'calendar--button-unvisible': !$setup.showNextArrow }]),
            onClick: $setup.nextMonth
          }, "›", 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedMonth) = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.months, (item, index) => {
              return _createElementVNode("option", {
                key: index,
                value: index + 1
              }, _toDisplayString(item), 9, _hoisted_4)
            }), 64))
          ], 512), [
            [_vModelSelect, $setup.selectedMonth]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedYear) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.years, (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: item
              }, _toDisplayString(item), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, $setup.selectedYear]
          ])
        ])),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "calendar--weekdays" }, [
      _createElementVNode("span", null, "Mo"),
      _createElementVNode("span", null, "Tu"),
      _createElementVNode("span", null, "We"),
      _createElementVNode("span", null, "Th"),
      _createElementVNode("span", null, "Fr"),
      _createElementVNode("span", null, "Sa"),
      _createElementVNode("span", null, "Su")
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["calendar--days", { 'element-no-clickable': !$props.withPicker }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.days, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["day", { selected: item.date === $setup.selectedDate && $props.withPicker, today: $props.showToday && item.date === $setup.formatDate() }]),
          key: index
        }, [
          (!item.hidden)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button",
                onClick: ($event: any) => ($setup.selectDate(item.date)),
                type: "button",
                disabled: item.disabled
              }, _toDisplayString(item.day), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2)
  ]))
}